<template>
  <div class="common-question">
    <div class="header-tool">
      <div class="header-tool-info">
        <Breadcrumb>
          <BreadcrumbItem>首页</BreadcrumbItem>
          <BreadcrumbItem>通用设置</BreadcrumbItem>
          <BreadcrumbItem>问券调查</BreadcrumbItem>
        </Breadcrumb>
        <div class="header-tool-title">问券调查</div>
      </div>
    </div>
    <div class="header-switch">
      <div class="header-switch-question">问券调查设置</div>
      <Button type="primary" @click="save()" style="margin-right:20px;">预览</Button>
      <Button type="primary" @click="save()">保存</Button>
    </div>

    {{list}}
    <div class="common-question-content">
      <div class="question">
        <div v-for="(item,index) in list" :key="index">
          <!-- 单选 -->
          {{item.radio}}
          <div class="question-list" v-for="(itm,idx) in item.radio" :key="idx">
            <div class="question-list-t">
              <div>{{index + 1}}. {{itm.title}}<span style="color: #de0808;" v-if="itm.require">*</span></div>
              <span v-if="!itm.visible" class="edit" @click="itm.visible=true;">点击编辑</span>
            </div>
            <div style="margin-left:20px;">
              <RadioGroup vertical>
                <Radio :label="im.title" v-for="(im,ix) in itm.listArr" :key="ix">
                  <Icon type="social-apple"></Icon>
                  <span v-if="im.title">{{im.title}}</span>
                  <!-- <span v-else>空白标题</span> -->
                </Radio>
                <Radio label="其他" v-if="itm.require2">
                  <Icon type="social-android"></Icon>
                  <span>其他</span>
                </Radio>
              </RadioGroup>
            </div>
            <div class="question-list-b" v-if="!itm.visible">
              <span @click="addRadio()"><i class="icon iconfont icon-jia3"></i></span>
              <span @click="delType1(index)"><i class="icon iconfont icon-lajitong"></i></span>
              <span @click="upType1(index)"><i class="icon iconfont icon-xiangshang1"></i></span>
              <span @click="downType1(index)"><i class="icon iconfont icon-xiangshang1" style="display:inline-block;transform:rotate(180deg);"></i></span>
            </div>
            <div class="question-list-edit" v-if="itm.visible">
              <div class="edit-top">
                <Input v-model="itm.title" style="width:50%;" placeholder="输入标题" />
                <Checkbox style="margin-left:20px;" v-model="itm.require">必填</Checkbox>
                <Checkbox style="margin-left:10px;" v-model="itm.require2">包含“其他”选项</Checkbox>
                <Button type="primary" @click="RadioFinish(itm)" style="position:absolute;top:9px;right:10px;">编辑完成</Button>
              </div>
              <div class="edit-content">
                <div class="edit-content-list" v-for="(im,ix) in itm.listArr" :key="ix">
                  <Input v-model="im.title" style="width:50%;" placeholder="输入标题" />
                  <div style="display:inline-block;display:flex;align-items:center;" class="question-list-b">
                    <span @click="addRadio3(itm.listArr,ix)"><i class="icon iconfont icon-jia3"></i></span>
                    <span @click="delRadio(itm.listArr,ix)"><i class="icon iconfont icon-lajitong"></i></span>
                    <span @click="upRadio(itm.listArr,ix)"><i class="icon iconfont icon-xiangshang1"></i></span>
                    <span @click="downRadio(itm.listArr,ix)"><i class="icon iconfont icon-xiangshang1" style="display:inline-block;transform:rotate(180deg);"></i></span>
                  </div>
                </div>
                <Button type="dashed" style="width:50%;font-size:16px;" @click="addRadio2(itm.listArr)">+</Button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="common-question-add">
      <div class="add-content">
        <div class="btn" @click="addRadio()">+</div>
        <span @click="addRadio()">单选题</span>
        <div class="line"></div>
        <div class="btn">+</div>
        <span>多选题</span>
        <div class="line"></div>
        <div class="btn">+</div>
        <span>问答题</span>
        <div class="line"></div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: "host-common-question",
  data() {
    return {
      list: [
        {
          radio: [
            {
              title: "单选标题",
              visible: false,
              require: false,
              require2: false,
              listArr: [
                {
                  title: "选项1",
                }
              ]
            }
          ],
        }
      ],
      // list: [
      //   {
      //     title: "单选标题",
      //     visible: false,
      //     require: false,
      //     require2: false,
      //     listArr: [
      //       {
      //         title: "选项1",
      //       }
      //     ]
      //   }
      // ],
    }
  },
  methods: {
    init() {

    },
    save() {
      let req = {

      }
      console.log(req);
    },
    addRadio() {
      this.list.push({
        radio: [
          {
            title: "单选标题",
            visible: false,
            require: false,
            require2: false,
            listArr: [
              {
                title: "选项1",
              }
            ]
          }
        ],
      });
    },
    // addType1(val) {
    //   this.list.push({
    //     radio: [
    //       {
    //         title: "单选标题",
    //         visible: false,
    //         require: false,
    //         require2: false,
    //         listArr: [
    //           {
    //             title: "选项1",
    //           }
    //         ]
    //       }
    //     ],
    //   });
    // },
    delType1(index) {
      this.list.splice(index,1);
    },
    upType1(index) {
      if (index !== 0) {
        this.list[index] = this.list.splice(index-1, 1, this.list[index])[0];
      }
    },
    downType1(index) {
      if (index !== this.list.length - 1) {
        this.list[index] = this.list.splice(index+1, 1, this.list[index])[0];
      }
    },
    addRadio3(val,index) {
      val.splice(index + 1,0,{
        title: "单选标题",
      })
    },
    addRadio2(value) {
      value.push({
        title: "单选标题",
      });
    },
    delRadio(val,index) {
      val.splice(index,1);
    },
    upRadio(val,index) {
      if (index !== 0) {
        val[index] = val.splice(index-1, 1, val[index])[0];
      }
    },
    downRadio(val,index) {
      if (index != val.length - 1) {
        val[index] = val.splice(index+1, 1, val[index])[0];
      }
    },
    RadioFinish(itm) {
      let res = true;
      if (itm.listArr && itm.listArr.length > 0) {
        itm.listArr.map(c => {
          if (!c.title) {
            res = false;
          }
        })
      }
      if (!res) {
        this.$Message.warning("标题内容不能为空");
        return;
      }
      itm.visible = false;
    }
  },
  created() {
  },
}
</script>

<style lang="scss" scoped>
.common-question {
  .header-switch {
    display: flex;
    align-items: center;
    padding: 0 25px 18px 35px;
    background: #fff;
    &-question {
      flex: 1;
      font-size: 14px;
      color: #808080;
    }
  }
  &-content {
    min-width: 1000px;
    padding: 25px;
    .question {
      background-color: #fff;
      padding: 30px 160px 30px 25px;
      &-list {
        border: solid 1px transparent;
        padding: 20px 20px 10px 20px;
        &:hover {
          transition: all .4s;
          border: solid 1px #1890ff;
        }
        &-t {
          position: relative;
          font-weight: bold;
          color: #222;
          .edit {
            position: absolute;
            top: 0;
            right: 0;
            color: #1890ff;
            &:hover {
              cursor: pointer;
            }
          }
        }
        &-b {
          text-align: right;
          span {
            display: inline-block;
            width: 20px;
            height: 20px;
            border: 1px solid #999;
            border-radius: 50%;
            margin-left: 8px;
            position: relative;
            i {
              position: absolute;
              left: 50%;
              margin-left: -8px;
              top: 50%;
              margin-top: -12px;
            }
            &:hover {
              cursor: pointer;
              // border: 1px solid #1890ff;
              i {
                color: #1890ff;
              }
            }
          }
        }
        &-edit {
          width: 100%;
          border: solid 1px #dddddd;
          position: relative;
          margin-top: 10px;
          .edit-top {
            width: 100%;
            height: 50px;
            padding: 10px 20px;
            background-color: #f5f5f5;
          }
          .edit-content {
            padding: 30px 0 30px 20px;
            &-list {
              display: flex;
              align-items: center;
              margin-bottom: 10px;
            }
          }
        }
      }
    }
  }
  &-add {
    min-width: 1000px;
    padding: 25px;
    .add-content {
      height: 50px;
      background-color: #fff;
      display: flex;
      align-items: center;
      // box-shadow: 0px 0px 7px 0px rgba(146, 160, 185, 0.2);
      .btn {
        width: 22px;
        height: 22px;
        background-color: #d13119;
        cursor: pointer;
        border-radius: 2px;
        text-align: center;
        line-height: 22px;
        font-size: 20px;
        color: #fff;
        margin-left: 18px;
      }
      span {
        padding: 0 15px 0 10px;
        cursor: pointer;
      }
      .line {
        width: 2px;
        height: 30px;
        background-color: #f0f2f5;
      }
    }
  }
}
</style>
<style lang="scss">
.common-question {
  .ivu-form .ivu-form-item-label {
    width: 100% !important;
    text-align: left;
  }
  .ivu-form-item-content {
    margin-left: 15px !important;
  }
  .ivu-form-item {
    border: solid 1px transparent;
    &:hover {
      transition: all .4s;
      border: solid 1px #1890ff;
    }
  }
  .ivu-btn:hover, .ivu-btn:focus, .ivu-btn:active, .ivu-btn:visited {
    color: #d13119;
  }
}
</style>